import type { Toast } from "./types";
import { getToastStyles } from "./utils";
import { getIcon } from "./utils";

interface ToastItemProps {
  toast: Toast;
  onClose: () => void;
  isExiting: boolean;
}

export const ToastItem = ({ toast, onClose, isExiting }: ToastItemProps) => {
  return (
    <div
      className={`${getToastStyles(toast)} border rounded-xl p-4 sm:p-5 backdrop-blur-sm shadow-global-card ${
        isExiting ? "animate-fade-out" : "animate-slide-in-right"
      } flex items-start gap-3 sm:gap-4 w-full sm:min-w-[380px] sm:max-w-md`}
      role="alert"
    >
      {getIcon(toast)}
      <p className="text-sm sm:text-base font-semibold flex-1 leading-relaxed break-words">
        {toast.message}
      </p>
      <button
        onClick={onClose}
        className="text-global-tertiary hover:text-global-secondary transition-colors flex-shrink-0 mt-0.5"
        aria-label="Cerrar notificación"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
};
